<template>
  <div class="inner-wrapper">
    <div class="inner-wrapper-md">
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="changePassword">
            <fieldset>
          <legend class="page-title">
            Reset your password
          </legend>

          <p class="body">
            Enter the new password for the account
            <span class="label-active">{{ this.Email }}</span
            >.
          </p>
          <AlertMessages />
            <div class="form-group">
              <div class="field-wrapper" v-flyout>
                <input
                  type="password"
                  class="text-field-3"
                  id="password"
                  autocomplete="new-password"
                      aria-label="Password"
                      aria-required="true"
                      :aria-invalid="$v.Password.$error"
                      aria-errormessage="errorPassword"
                      aria-describedby="passwordFormatDetails"
                  ref="password"
                  v-model="Password"
                  :class="{ 'is-invalid': $v.Password.$error }"
                />
<i @click.prevent="showPassword"  :class="iconId"></i>
                <div class="field-placeholder" v-animate>
                  <span class="asterisk">Password</span>
                </div>
              </div>
              <div id="errorPassword" v-if="$v.Password.$error" class="feedback">
                <span v-if="!$v.Password.required">This field is required</span>
                <span v-if="!$v.Password.minLength"
                  >Password must be at least 8 characters</span
                >
                <span v-if="!$v.Password.strongPassword"
                  >Password must contain a lowercase character, uppercase
                  character, a number and a special character</span
                >
              </div>
              <p id="passwordFormatDetails" class="label-info pt-2">
                Must be at least 8 characters and contain a lowercase character,
                uppercase character, a number and a special character.
              </p>
            </div>
            <div class="form-row cta-group">
              <!-- <router-link
          class="cta-white-169"
          :to="{ name: '' }"
          @click.native="resetPassword()"
        >
          Reset password<font-awesome-icon icon="angle-right" size="lg" />
        </router-link> -->
              <button role="button" class="cta-white-206">
                Reset password<span class="angle-right-white"></span>
              </button>
            </div>
          </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import router from "../router";
import { mapState, mapActions, mapGetters } from "vuex";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";
import { required, minLength } from "vuelidate/lib/validators";
import { publicRouter } from "../router";

export default {
  name: "PasswordNew",
  components: { AlertMessages },
 data() {
    return {
      showEyeIcon: false
    };
  },
  async created() {
    await this.getUsername({ key: this.$route.query.key });
  },
  validations: {
    Password: {
      required,
      minLength: minLength(8),
      strongPassword: password => {
        if (
          typeof password == "undefined" ||
          password == null ||
          password == ""
        )
          return true;
        return (
         // password.length >= 8 &&
          /[a-z]/.test(password) &&
          /[A-Z]/.test(password) &&
          /[0-9]/.test(password) &&
              /[!@#$%^&*(),.?":{}|<>]/.test(password)
        );
      }
    }
  },
  // mounted:{

  // },

  methods: {
    ...mapActions("account", ["getUsername", "resetPassword"]),
    ...mapActions("alert", ["clear"]),
    showPassword(){
  this.showEyeIcon = !this.showEyeIcon;
    if (this.$refs.password.type == "password") {
        this.$refs.password.type = "text";
      } else {
        this.$refs.password.type="password";
      }
},
    async changePassword() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let result = await this.resetPassword({
        password: this.Password,
        key: this.$route.query.key
      });
      if (!this.hasError && result)
        publicRouter.push({
          name: "password-reset",
          query: {
            id: 4
          }
        });
    }
  },
  computed: {
    ...mapState("users", ["user"]),
    ...mapState("account", ["status"]),
    ...mapGetters("alert", ["hasError"]),
     iconId() { 
    
      return this.showEyeIcon ? "eye-on" : "eye-off";
    },
    Password: {
      get() {
        return this.user.Password;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Password: val });
      }
    },
    Email: {
      get() {
        return this.status.Email;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
